import { useTran } from "../../hooks/useTran";
import { cn } from "../../utils/utils";

export const MyTextarea = ({
  className,
  inputClassName,
  label,
  placeholder,
  error,
  ...props
}) => {
  const { t } = useTran();
  return (
    <div className={cn("space-y-1", className)}>
      {label ? (
        <label className="block font-medium text-gray-700">{t(label)}</label>
      ) : null}
      <textarea
        placeholder={t(placeholder)}
        className={cn(
          "flex min-h-[80px] w-full rounded-md border-border border bg-background px-3 py-2 transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-gray-400 focus-visible:bg-accent/50 disabled:cursor-not-allowed disabled:opacity-50",
          inputClassName,
        )}
        {...props}
      />
      {error ? <small className="text-error text-xs">{error}</small> : null}
    </div>
  );
};
MyTextarea.displayName = "Textarea";
